import type { FC, PropsWithChildren } from 'react';

import { isFeatureEnabled } from '@luna/gatekeeper';
import type { PublicTemporaryMessage } from '@api-client/temporary-messages';

import { TemporaryMessagesContainer } from './messages-header/TemporaryMessagesContainer';
import styles from './StickyHeaderWithTemporaryMessage.module.scss';

interface Props {
    displayedMessage: PublicTemporaryMessage | undefined;
    trigger: string | undefined;
}

export const StickyHeaderWithTemporaryMessage: FC<PropsWithChildren<Props>> = ({
    children,
    displayedMessage,
    trigger,
}) => {
    const shouldDisplayMessage = isFeatureEnabled((f) => f.temporaryMessages) && displayedMessage;
    return (
        <div className={styles.header}>
            {shouldDisplayMessage && (
                <TemporaryMessagesContainer displayedMessage={displayedMessage} trigger={trigger} />
            )}
            {children}
        </div>
    );
};
